import React from "react";
import {DateRange} from "../../../../../global/dateRange";
import { TimeRange } from "../../../../../global/timeRange";
import {MultipleCheckbox} from "../../../../../global/checkboxes/multipleCheckbox";
import {CubicFitRange} from "../../../../../global/cubicFitRange";
import {Typography, Box} from "@mui/material";
import {SearchByField} from "../../../../../global/searchByField";

export const FilterContentByData = ({el, filterParams, setFilterParams}) => (
    <Box sx={{p: 3, width: 382}}>
        <Typography
            sx={{mb: 2}}
            variant="h2"
            component="div"
            fontWeight="700"
            color="#2B3033"
            textTransform="capitalize"
        >
            {el?.displayField}
        </Typography>

        {el.type === 'date_range' && (
            <DateRange
                el={el}
                filterParams={filterParams}
                setFilterParams={setFilterParams}
            />
        )}
        {el.type === 'time_range' && (
            <TimeRange
                el={el}
                filterParams={filterParams}
                setFilterParams={setFilterParams}
            />
        )}

        {el.type === 'checkbox' && <MultipleCheckbox
            el={el}
            filterParams={filterParams}
            setFilterParams={setFilterParams}
        />}

        {el.type === 'number_range' && <CubicFitRange el={el}/>}

        {el.type === 'input' && <SearchByField el={el}/>}

    </Box>
)
